<template>
  <div>
    <DataTable :headers="headers" :path="path" :filter-path="filterPath" actionButtonsName="NotificationActionButtons"
               :properties="properties" toolbar toolbar-title="Notificaciones SIC" filter slot-name="first-column"
               :defaults="defaults" search-text="Buscar por título o mensaje">
      <template slot="first-column" slot-scope="props">
        <td class="text-xs-left table-row">
          <v-chip :color="colorList[props.item.notification.urgency]" small text-color="white">{{ props.item.notification.urgency }}</v-chip>
        </td>
      </template>
    </DataTable>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newNotification">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Prioridad', value: 'urgency', filterField: true, sortable: false, align: 'left' },
        { text: 'Fecha', value: 'created_at', sortable: false, align: 'left' },
        { text: 'Categoría', sortable: false, align: 'left' },
        { text: 'Asunto', sortable: false, align: 'left' },
        { text: 'Mensaje', sortable: false, align: 'left' },
        { text: 'Leído', value: 'read', sortable: false, visible: false, filterField: true, align: 'left' },
        { text: 'Acciones', align: 'right', sortable: false }
      ],
      properties: ['notification.createdAt', 'notification.contentType', 'notification.title', 'notification.message'],
      defaults: { 'notification.contentType': 'Notificación Manual' },
      path: 'notifications/all',
      filterPath: 'filters/notifications',
      colorList: {
        'Alta': 'red darken-1',
        'Normal': '#0BBAD9',
        'Baja': 'yellow darken-2'
      }
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddNotificaciones
    }
  },

  methods: {
    newNotification () {
      this.$router.push({ name: 'nuevaNotificacion' })
    }
  }
}
</script>

<style scoped>
.table-row {
  background-color: white;
  border-bottom: 1px solid #959ba6;
}
</style>
